import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import Tables from './containers';
import { DiningReservationV2, DiningV2 } from './v2';

type TablesVersionProps = {
  language: string;
  openModal?: boolean;
  openModalWith?: { value: string | string[] | undefined };
};

export const TablesVersion: FC<TablesVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');

  if (isV2) {
    if (props.openModal) {
      const restaurant = props.openModalWith?.value;
      const restaurantId = Array.isArray(restaurant) ? restaurant[0] : restaurant;
      return <DiningReservationV2 restaurantId={restaurantId} />;
    }
    return <DiningV2 />;
  }

  return <Tables {...props} />;
};
